var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "手机号"
    }
  }, [_c("el-input", {
    attrs: {
      clearable: ""
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getSimulationData("search");
      }
    },
    model: {
      value: _vm.searchForm.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "phone", $$v);
      },
      expression: "searchForm.phone"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "城市"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getSimulationData("search");
      }
    },
    model: {
      value: _vm.searchForm.cityId,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "cityId", $$v);
      },
      expression: "searchForm.cityId"
    }
  }, _vm._l(_vm.cityList, function (item) {
    return _c("el-option", {
      key: item.token,
      attrs: {
        label: item.name_zh,
        value: item.token
      }
    });
  }), 1)], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getSimulationData("search");
      }
    }
  }, [_vm._v("搜索 ")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: function click($event) {
        _vm.searchForm = {
          page: 1,
          size: 20,
          phone: "",
          cityId: "15102233103895305"
        };
        _vm.getSimulationData("search");
      }
    }
  }, [_vm._v("重置 ")])], 1)], 1)], 1), _c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "simulation-wrap"
  }, [_vm.userInfo.id ? _c("UserInfo", {
    attrs: {
      userInfo: _vm.userInfo
    }
  }) : _vm._e(), _c("div", {
    staticClass: "simulation-list",
    style: {
      height: "calc(100% - ".concat(_vm.otherHeight, "px)")
    }
  }, [_vm._l(_vm.list, function (item, index) {
    var _vm$flowList, _vm$flowList2;
    return _c("div", {
      key: index,
      staticClass: "simulation-item"
    }, [_c("div", {
      staticClass: "item-header"
    }, [_c("div", {
      staticClass: "item-title"
    }, [_c("a", {
      on: {
        click: function click($event) {
          return _vm.toLink(item);
        }
      }
    }, [_vm._v(_vm._s(item.title) + " ")])]), _c("div", {
      staticClass: "right-box"
    }, [item !== null && item !== void 0 && item.flowPool ? _c("div", {
      staticClass: "flow-pool"
    }, [_c("el-tag", {
      attrs: {
        size: "mini",
        type: (_vm$flowList = _vm.flowList) === null || _vm$flowList === void 0 ? void 0 : _vm$flowList[item.flowPool].type
      }
    }, [_vm._v(_vm._s((_vm$flowList2 = _vm.flowList) === null || _vm$flowList2 === void 0 ? void 0 : _vm$flowList2[item.flowPool].text))])], 1) : _vm._e(), _c("div", {
      staticClass: "item-score"
    }, [_vm._v(" 推荐分：" + _vm._s(item.score || 0) + " ")])])]), _c("div", {
      staticClass: "item-content"
    }, [_c("div", {
      staticClass: "item-info"
    }, [_c("div", {
      staticClass: "user-box"
    }, [_vm._v("作者：" + _vm._s(item.username || "") + " "), _c("wlc-user-type", {
      attrs: {
        user: item.user
      }
    })], 1), _c("div", [item.user.remark ? _c("span", [_vm._v(" 备注：" + _vm._s(item === null || item === void 0 ? void 0 : item.user.remark) + " ")]) : _vm._e()]), _c("div", [_vm._v("城市：" + _vm._s(_vm.setCity(item)))]), _c("div", [_c("span", {
      staticStyle: {
        "margin-right": "10px"
      }
    }, [_vm._v("收藏：" + _vm._s(item.collectCount || 0) + " ")]), _c("span", {
      staticStyle: {
        "margin-right": "10px"
      }
    }, [_vm._v(" 浏览：" + _vm._s(item.viewCount || 0) + " ")]), _c("span", [_vm._v(" 评论：" + _vm._s(item.commentCount || 0))])]), _c("div", [_vm._v("发布时间：" + _vm._s(item.createdAt))]), _c("div", [_vm._v(" 分类：" + _vm._s(_vm.manageArr(item.adminCategoryNames, item.textCategoryNames)) + " ")])]), item.coverUrl ? _c("div", {
      staticClass: "item-image"
    }, [_c("img", {
      attrs: {
        src: item.coverUrl,
        alt: "",
        onerror: "this.style.display='none';"
      }
    })]) : _vm._e()])]);
  }), _vm.list.length > 0 ? _c("div", {
    staticClass: "load-more-status"
  }, [_vm.loadingMore ? _c("div", {
    staticClass: "loading-more"
  }, [_c("i", {
    staticClass: "el-icon-loading"
  }), _vm._v(" 加载中... ")]) : _vm.noMore ? _c("div", {
    staticClass: "no-more"
  }, [_vm._v("没有更多数据了")]) : _vm._e()]) : _vm._e(), !_vm.loading && _vm.list.length === 0 ? _c("div", {
    staticClass: "no-data"
  }, [_vm._v(" 暂无数据 ")]) : _vm._e()], 2), _c("el-backtop", {
    attrs: {
      target: ".simulation-list",
      "visibility-height": 800,
      bottom: 50,
      right: 50
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };